export var SET_EVENTS = 'SET_EVENTS';
export var setEvents = function setEvents(events) {
  return {
    type: SET_EVENTS,
    events: events
  };
};